import FlexBox from "lib/components/common/flex-box";
import SimpleCard from "lib/components/common/simple-card";
import TabBar from "lib/components/common/tab-bar";
import DashboardLayout from "lib/components/layouts/dashboard";
import { FC } from "react";
import {
  PiStorefrontLight,
  PiHandHeartLight,
  // PiShoppingCartSimpleLight,
  PiUserLight,
  PiUsersLight,
  PiPackageLight,
} from "react-icons/pi";
import { useSearchParams } from "react-router-dom";
import Clinics from "./clinic/Clinics";
import Therapies from "./therapy/therapies";
import UserTab from "./users/user-tab";
import Practitioners from "./practitioner/Practitioners";
import Subscriptions from "./subscription/Subscriptions";
import Packages from "./package/packages";
import MembershipPackages from "./membershippackage/membership-packages";
import { PAGE_ROUTES } from "lib/constants/page-routes";

const BreadcrumbItems = [
  {
    label: "Dashboard",
    path: PAGE_ROUTES.ADMIN.Dashboard,
  },
  {
    label: "Configurations",
    path: PAGE_ROUTES.ADMIN.Configurations,
  },
] as BreadcrumbItem[];

// To Do: Check where is this used
const CONFIGURATION_OPTIONS = [
  {
    id: 0,
    label: "Clinics",
    icon: <PiStorefrontLight size={24} />,
    href: PAGE_ROUTES.Root,
  },
  {
    id: 1,
    label: "Therapies",
    icon: <PiHandHeartLight size={24} />,
    href: PAGE_ROUTES.Root,
  },
  {
    id: 2,
    label: "Packages",
    icon: <PiPackageLight size={24} />,
    href: PAGE_ROUTES.Root,
  },
  {
    id: 3,
    label: "Membership Packages",
    icon: <PiPackageLight size={24} />,
    href: PAGE_ROUTES.Root,
  },
  {
    id: 4,
    label: "Practitioners",
    icon: <PiUserLight size={24} />,
    href: PAGE_ROUTES.Root,
  },
  // {
  //   id: 5,
  //   label: "Subscriptions",
  //   icon: <PiShoppingCartSimpleLight size={24} />,
  //   href: PAGE_ROUTES.Root,
  // },
  {
    id: 6,
    label: "Users",
    icon: <PiUsersLight size={24} />,
    href: PAGE_ROUTES.Root,
  },
] as GeneralItem[];

const TABS = {
  clinics: 0,
  therapies: 1,
  packages: 2,
  membershipPackages: 3,
  practitioners: 4,
  subscriptions: 5,
  users: 6,
};

interface ConfigurationsHomeProps {}

const ConfigurationsHome: FC<ConfigurationsHomeProps> = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const selectedTab = searchParams.get("tab") || "clinics";
  const selectedTabId = TABS[selectedTab] ?? 0;

  const setSelectedTabId = (tabId: number) => {
    searchParams.set(
      "tab",
      Object.keys(TABS).find((key) => TABS[key] === tabId) || "clinics"
    );
    setSearchParams(searchParams);
  };

  return (
    <DashboardLayout breadcrumbItems={BreadcrumbItems}>
      <SimpleCard className="page-height">
        <FlexBox>
          <h4>Configurations</h4>
          <TabBar
            tabs={CONFIGURATION_OPTIONS}
            selectedTabId={selectedTabId}
            onTabChange={setSelectedTabId}
          />
        </FlexBox>
        <hr />
        {selectedTabId === 0 && <Clinics />}
        {selectedTabId === 1 && <Therapies />}
        {selectedTabId === 2 && <Packages />}
        {selectedTabId === 3 && <MembershipPackages />}
        {selectedTabId === 4 && <Practitioners />}
        {selectedTabId === 5 && <Subscriptions />}
        {selectedTabId === 6 && <UserTab />}
      </SimpleCard>
    </DashboardLayout>
  );
};

export default ConfigurationsHome;
